import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M10.586 8.414 7 12a1.414 1.414 0 0 0 2 2l3-3 3 3a1.414 1.414 0 1 0 2-2l-3.586-3.586a2 2 0 0 0-2.828 0"
    }
  )
);
var SvgChevronUpOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ChevronUpOutlined_default = SvgChevronUpOutlined;

export { ChevronUpOutlined_default as default };
